/**
 * ★ nửa sao dùng chung cho MỌI chỗ render sao bằng JS.
 *
 * Là bản SONG SINH của snippet `review-star-band.liquid` (band) +
 * `review-stars-text.liquid` (markup) — port `getSummaryStar`
 * (ps_reviewCnet.php:219-245). Đổi band phải đổi cả 3 (Liquid snippet, file này,
 * `ReviewService::summaryStarBand` phía Laravel).
 *
 * KHÔNG dùng `Math.round(rating)`: band so sánh biên `<= .2` / `<= .7` nên 3.8
 * ra 4.0 nhưng 4.25 ra 4.5, và `0 < x <= 1.2` LUÔN ra 1 sao (không có mức 0.5).
 *
 * Markup dùng inline style, KHÔNG class Tailwind: Tailwind JIT chỉ scan file
 * `.liquid` → class sinh trong string JS có thể không được emit.
 *
 * Usage:
 *   el.innerHTML = window.inkReviewStars.html(4.25);              // 4.5 sao
 *   el.innerHTML = window.inkReviewStars.html(r.summary, { fill: '#f59e0b' });
 *   window.inkReviewStars.band('4.6');                            // 4.5
 */
(function () {
  'use strict';

  // Cam design (= --color-ink-orange) cho phần sao đầy, xám gray-300 cho phần rỗng.
  const FILL = '#ff8a1c';
  const EMPTY = '#d1d5db';

  /**
   * Điểm TB thô → mức sao 0 / 1 / 1.5 / ... / 5. Idempotent (truyền lại giá trị
   * đã band trả về chính nó) → dùng được cho cả `avg_rating` thô lẫn field `star`
   * do Laravel band sẵn.
   */
  function band(rating) {
    const r = Number(rating) || 0;
    if (r === 0) return 0;
    if (r <= 1.2) return 1;
    if (r <= 1.7) return 1.5;
    if (r <= 2.2) return 2;
    if (r <= 2.7) return 2.5;
    if (r <= 3.2) return 3;
    if (r <= 3.7) return 3.5;
    if (r <= 4.2) return 4;
    if (r <= 4.7) return 4.5;
    return 5;
  }

  /**
   * HTML 5 sao có nửa sao: lớp ★ đầy clip theo % phủ lên nền ★ rỗng.
   * KHÔNG để whitespace giữa 2 span con — text node trắng chiếm ~0.25em trong
   * inline box của span cha → % tính trên chiều rộng lớn hơn 5 sao, nửa sao lệch.
   */
  function html(rating, opts) {
    const o = opts || {};
    const fill = o.fill || FILL;
    const empty = o.empty || EMPTY;
    const value = band(rating);
    const pct = (value / 5) * 100;

    return (
      '<span role="img" aria-label="' + value.toFixed(1) + '/5"' +
      ' style="position:relative;display:inline-block;white-space:nowrap;line-height:1">' +
      '<span style="color:' + empty + '">★★★★★</span>' +
      '<span style="position:absolute;left:0;top:0;overflow:hidden;width:' + pct + '%;color:' + fill + '">★★★★★</span>' +
      '</span>'
    );
  }

  window.inkReviewStars = { band: band, html: html };
})();
